
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import AppMainLayout from "@/layouts/AppMainLayout.vue";
import { namespace } from "vuex-class";
import { updateTitle } from "./utils/titleUpdater";
import { calcColorDiffTexto } from "@/utils/fontColorDifCalculator";
import axios from "axios";
import { translateColorToHex } from "./utils/colors";
import imageService from "@/services/ImageService";
import { bootstrap, setOptions } from "vue-gtag";
// import "jivoChat.js";

const AppConfigStore = namespace("AppConfig");

@Component({
  name: "App",
  components: {
    AppMainLayout,
  },
})
export default class App extends Vue {
  @AppConfigStore.Getter
  private getConfigsVisuais!: any;

  @AppConfigStore.Getter
  private getAplicativo!: any;

  loading = true;

  mounted() {
    this.updatePageFavicon();
    this.updateAddressBarColor();
  }

  @Watch("getAplicativo", { deep: true })
  onAplicativoChanged(value: any, oldValue: any) {
    // Google Analytics
    if (value?.googleAnalyticsId) {
      setOptions({
        config: {
          id: value.googleAnalyticsId,
        },
      });

      bootstrap().then(() => {
        console.log("Google Analytics is ready to track");
      });
    }

    if (value?.jivoChatId) {
      // Cria um novo script element
      const script = document.createElement("script");
      script.src = "//code.jivosite.com/widget/" + value.jivoChatId;
      script.async = true;

      // Adiciona o script ao body do documento
      document.body.appendChild(script);

      // Opcional: callback quando o script for carregado
      script.onload = () => {
        console.log("JivoChat carregado com sucesso!");
      };
    }
  }

  async updatePageFavicon() {
    let favicon = document.querySelector('link[rel="icon"]');
    if (!favicon) {
      favicon = document.createElement("link");
      favicon.setAttribute("rel", "icon");
      favicon.setAttribute("type", "image/x-icon");
      favicon.setAttribute("href", "<%= BASE_URL %>favicon.ico");
      document.head.appendChild(favicon);
    }

    const url = await imageService.makeIconeImageURL();
    const response = await axios
      .get(url, { responseType: "arraybuffer" })
      .catch(() => null);
    if (!response?.data) return;
    const byteArray = new Uint8Array(response.data) as any;

    const type = response.headers["content-type"];
    const dataURL = `data:${type};base64,${btoa(
      String.fromCharCode.apply(null, byteArray)
    )}`;

    favicon.setAttribute("type", type);
    favicon.setAttribute("href", dataURL);
  }

  updateAddressBarColor() {
    const themeColorEl = window?.document.querySelectorAll(
      'meta[name="theme-color"]'
    );
    if (!themeColorEl) return;
    themeColorEl.forEach((meta) => {
      const colorHex = translateColorToHex("header", this.$vuetify);
      meta.setAttribute("content", colorHex);
    });
  }

  @Watch("getConfigsVisuais", { deep: true })
  onConfigsVisuaisChanged(value: any, oldValue: any) {
    if (value?.cores?.fundo)
      this.$vuetify.theme.themes.light["header"] = value.cores.fundo;

    if (value?.cores?.principal)
      this.$vuetify.theme.themes.light["primary"] = value.cores.principal;

    if (value?.cores?.texto)
      this.$vuetify.theme.themes.light["texto"] = value.cores.texto;

    this.$vuetify.theme.themes.light["tituloPainel"] =
      calcColorDiffTexto(this.$vuetify.theme.themes.light["primary"]) ||
      this.$vuetify.theme.themes.light["tituloPainel"];

    updateTitle(this.$router.currentRoute.name || "");
    this.updateAddressBarColor();
  }
}
